"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processExpressionListTokens = exports.processTokenExpressionTokens = exports.processTextExpressionTokens = exports.processExpressionTokens = exports.processAnyValueTokens = void 0;
const token_processors_1 = require("./token-processors");
const error_classes_1 = __importDefault(require("../error-classes"));
const types_1 = require("./types");
function getInvalidItems(errorType, errors) {
    return errors
        .filter((error) => error.type === errorType)
        .reduce((soFar, error) => [...soFar, ...error.items], []);
}
function errorItemsString(items) {
    return items.map((item) => `' ${item} '`).join(', ');
}
function processAnyValueTokens(rawTokens) {
    return {
        getValue: () => rawTokens[0].value,
        dependencies: [],
    };
}
exports.processAnyValueTokens = processAnyValueTokens;
function processExpressionTokens(rawTokens, name, lookups) {
    const { systemFunctions } = lookups;
    const processed = (0, token_processors_1.processTokens)(rawTokens, token_processors_1.expressionProcessors);
    const expressionErrors = [];
    const unknownFunctions = processed.fnDependencies.filter((fn) => !systemFunctions[fn]);
    const invalidChars = getInvalidItems('invalidChars', processed.errors);
    if (unknownFunctions.length)
        expressionErrors.push(`The '${name}' expression includes unknown functions: [ ${unknownFunctions.join(', ')} ].`);
    if (invalidChars.length)
        expressionErrors.push(`The '${name}' expression includes invalid characters: [ ${invalidChars.join(', ')} ].`);
    if (expressionErrors.length)
        throw new error_classes_1.default.ValueRuleError(processed.errors.join('~§~'));
    const expression = processed.tokens.map((t) => t.value).join('');
    return {
        expression,
        getValue: (state) => eval(expression),
        dependencies: processed.dependencies,
    };
}
exports.processExpressionTokens = processExpressionTokens;
function processTextExpressionTokens(rawTokens, name, lookups) {
    const { systemFunctions } = lookups;
    const processed = (0, token_processors_1.processTokens)(rawTokens, token_processors_1.textExpressionProcessors);
    const expressionErrors = [];
    const unknownFunctions = processed.fnDependencies.filter((fn) => !systemFunctions[fn]);
    const invalidChars = getInvalidItems('invalidToken', processed.errors);
    if (unknownFunctions.length)
        expressionErrors.push(`The '${name}' expression includes unknown functions: ${errorItemsString(unknownFunctions)}.`);
    if (invalidChars.length)
        expressionErrors.push(`The '${name}' expression includes invalid characters: ${invalidChars.join(', ')}.`);
    if (expressionErrors.length)
        throw new error_classes_1.default.ValueRuleError(expressionErrors.join('~§~'));
    const expression = processed.tokens.map((t) => t.value).join('');
    return {
        expression,
        getValue: (state) => eval(expression),
        dependencies: processed.dependencies,
    };
}
exports.processTextExpressionTokens = processTextExpressionTokens;
function processTokenExpressionTokens(rawTokens, name, lookups) {
    const { values = [] } = lookups;
    const processed = (0, token_processors_1.processTokens)(rawTokens, token_processors_1.tokenExpressionProcessors);
    const invalidItems = getInvalidItems('invalidPlaceholder', processed.errors);
    if (invalidItems.length)
        throw new error_classes_1.default.ValueRuleError(`Placeholders should contain single value names but at least one has invalid contents: ${errorItemsString(invalidItems)}.`);
    const processedTokens = processed.tokens.map((t) => {
        var _a;
        if (t.type === types_1.TokenType.PLACEHOLDER) {
            const valueTypeId = (_a = values.find((v) => v.name === t.placeholder)) === null || _a === void 0 ? void 0 : _a.type;
            return Object.assign(Object.assign({}, t), { valueTypeId });
        }
        return t;
    });
    return {
        getValue: (state) => processedTokens.map((t) => t.type === types_1.TokenType.PLACEHOLDER ? Object.assign(Object.assign({}, t), { value: eval(t.value) }) : t),
        dependencies: processed.dependencies,
    };
}
exports.processTokenExpressionTokens = processTokenExpressionTokens;
function processExpressionListTokens(rawTokens, name, lookups) {
    const { systemFunctions } = lookups;
    const processed = rawTokens.map((token) => {
        const tokens = token.value;
        return processExpressionTokens(tokens, name, systemFunctions);
    });
    const dependencies = processed.map((p) => p.dependencies).reduce((soFar, p) => [...soFar, ...p], []);
    return {
        getValue: (state) => processed.map((p) => p.getValue(state)),
        dependencies: [...new Set(dependencies)],
    };
}
exports.processExpressionListTokens = processExpressionListTokens;
